import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Allprojects = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M40.508 4.02a6.613 6.613 0 0 0-9.379 0L5.388 29.82c-.1.1-.2.3-.3.4l-3.492 11.3v.1c-.1.4.1.8.3 1.1.2.2.598.4 1.097.3h.1l11.175-3.5c.2-.1.299-.1.399-.3l25.741-25.8c2.794-2.7 2.794-6.9.1-9.4ZM4.19 40.42l2.395-7.9 5.488 5.5-7.883 2.4Zm9.778-3.4-6.385-6.4 21.152-21.2 6.385 6.4-21.152 21.2Zm25.143-25.1-2.494 2.5-6.386-6.4 2.495-2.5c1.796-1.8 4.689-1.8 6.385 0 1.696 1.7 1.696 4.6 0 6.4ZM19.356 11.22c-.4.4-1.098.4-1.497 0l-1.097-1.1-2.993 3c-.4.4-1.098.4-1.497 0s-.399-1.1 0-1.5l2.993-3-2.694-2.7-2.993 3c-.399.4-1.097.4-1.496 0-.4-.4-.4-1.1 0-1.5l2.993-3-1.397-1.4-7.084 7.1 7.383 7.4c.4.4.4 1.1 0 1.5-.399.4-1.097.4-1.496 0l-8.182-8.2c-.399-.4-.399-1.1 0-1.5L8.88.72c.4-.4 1.098-.4 1.497 0l8.88 8.9c.5.5.5 1.2.1 1.6ZM44 34.82c0 .3-.1.5-.3.7l-8.58 8.6c-.399.4-1.097.4-1.496 0l-8.68-8.6c-.4-.4-.4-1.1 0-1.5.398-.4 1.097-.4 1.496 0l7.982 8 7.084-7.1-1.497-1.6-2.993 3c-.4.4-1.098.4-1.497 0s-.399-1.1 0-1.5l2.994-3-2.595-2.7-2.993 3c-.399.4-1.097.4-1.496 0-.4-.4-.4-1.1 0-1.5l2.993-3-1.197-1.1c-.4-.4-.4-1.1 0-1.5.399-.4 1.097-.4 1.496 0l8.98 9c.2.3.299.5.299.8Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M36.617 27.02c-.1-.1-.1-.1 0 0Z"
  })));
});
Allprojects.displayName = 'Allprojects';
Allprojects.defaultProps = {
  'aria-label': 'Allprojects'
};
export default Allprojects;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/AllProjects.js
// module id = 3094
// module chunks = 11